<template>
  <div>
    The available propellant can be specified by the mass of propellant
    or by the total impulse. If this limit is reached during the
    simulation, an error will be raised.
  </div>
</template>

<script>
export default {
  name: 'tooltipPropellantCapacity'
}
</script>
